import type { TradeInAemEHubPayload } from "../../utils/types";
import type { TradeInAemIntegratedParentComponentType, TradeInAemVersion } from "../../utils/constants";
import type { FormInfoResponseType } from "../../../common-deprecated/utils/contactFormUtils";

export const TRADE_IN_AEM_SET_EHUB_FAILED = "tradeInAem/setEHubFailed";
type TradeInAemSetEHubFailed = { type: typeof TRADE_IN_AEM_SET_EHUB_FAILED; failed: boolean };
export const setEHubFailed = (failed: boolean): TradeInAemSetEHubFailed => ({
    type: TRADE_IN_AEM_SET_EHUB_FAILED,
    failed,
});

export const TRADE_IN_AEM_SET_EHUB_SUBMITTING = "tradeInAem/setSubmitting";
type TradeInAemSetEHubSubmitting = {
    type: typeof TRADE_IN_AEM_SET_EHUB_SUBMITTING;
    submitting: boolean;
    latestPayload: TradeInAemEHubPayload | null;
};
export const setEHubSubmitting = (
    submitting: boolean,
    latestPayload: TradeInAemEHubPayload | null = null,
): TradeInAemSetEHubSubmitting => ({
    type: TRADE_IN_AEM_SET_EHUB_SUBMITTING,
    submitting,
    latestPayload,
});

export const TRADE_IN_AEM_SET_EHUB_LATEST_RESPONSE = "tradeInAem/setEHubLatestResponse";
type TradeInAemSetEHubResponse = {
    type: typeof TRADE_IN_AEM_SET_EHUB_LATEST_RESPONSE;
    latestResponse: FormInfoResponseType;
};
export const setEHubLatestResponse = (latestResponse: FormInfoResponseType): TradeInAemSetEHubResponse => ({
    type: TRADE_IN_AEM_SET_EHUB_LATEST_RESPONSE,
    latestResponse,
});

export const TRADE_IN_AEM_SET_VERSION = "tradeInAemSetVersion";
export type TradeInAemSetVersion = { type: typeof TRADE_IN_AEM_SET_VERSION; version: TradeInAemVersion };
export const setTradeInAemVersion = (version: TradeInAemVersion): TradeInAemSetVersion => ({
    type: TRADE_IN_AEM_SET_VERSION,
    version,
});

export const TRADE_IN_AEM_SET_PARENT_COMPONENT = "tradeInAemSetParentComponent";
export type TradeInAemSetParentComponent = {
    type: typeof TRADE_IN_AEM_SET_PARENT_COMPONENT;
    parentComponent: TradeInAemIntegratedParentComponentType | null;
};
export const setTradeInAemParentComponent = (
    parentComponent: TradeInAemIntegratedParentComponentType | null,
): TradeInAemSetParentComponent => ({
    type: TRADE_IN_AEM_SET_PARENT_COMPONENT,
    parentComponent,
});

export const TRADE_IN_AEM_SET_SHOW_IN_MODAL = "tradeInAemSetShowInModal";
export type TradeInAemSetShowInModal = { type: typeof TRADE_IN_AEM_SET_SHOW_IN_MODAL; show: boolean };
export const setTradeInSetShowInModal = (show: boolean): TradeInAemSetShowInModal => ({
    type: TRADE_IN_AEM_SET_SHOW_IN_MODAL,
    show,
});

export const TRADE_IN_AEM_SET_USE_TEST_DATA = "tradeInAemSetUseTestData";
export type TradeInAemUseTestData = { type: typeof TRADE_IN_AEM_SET_USE_TEST_DATA; useTestData: boolean };
export const setTradeInAemUseTestData = (useTestData: boolean): TradeInAemUseTestData => ({
    type: TRADE_IN_AEM_SET_USE_TEST_DATA,
    useTestData,
});

export type TradeInAemUtilsActions =
    | TradeInAemSetEHubFailed
    | TradeInAemSetEHubSubmitting
    | TradeInAemSetEHubResponse
    | TradeInAemSetVersion
    | TradeInAemSetParentComponent
    | TradeInAemSetShowInModal
    | TradeInAemUseTestData;
